// @flow
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { remCalc, getPhoneMediaQueriedStyle, getPropertyStyle } from '../../util/style-util';
import { textColor } from '../../styles/style-constants';
import classNames from 'classnames';
import shell from '../../images/naut.png';
import growWordLogoBlack from '../../images/grow-word-logo-black.png';
import doubleQuote from '../../images/double-quote.png';

type Props = {
  simple: booelan,
  showQuotes: boolean,
  onTermsClick: () => void,
  lang: any,
  classes: Object
}

const GwuFooter = ({ simple, showQuotes, onTermsClick, lang, classes }: Props) => {
  const quoteNumber = 1;

  const renderQuotes = () => {
    if (!showQuotes) {
      return null;
    }

    return (
      <div className={classes.top}>
        <div className={classes.quoteImg}>
          <img
            src={doubleQuote}
            alt={'Double Quote'}
          />
        </div>
        <div className={classes.quote}>
          {lang.t(`footer.quote${quoteNumber}`)}
        </div>
        <div className={classes.quoteBy}>
          &mdash; {lang.t(`footer.quoteBy${quoteNumber}`)}
        </div>
      </div>
    );
  };

  console.log(lang.t('onboarding.terms.title2'));

  return (
    <footer className={classes.footer}>
      {renderQuotes()}
      <div className={simple ? classes.bottomSimple : classNames(classes.bottom, 'gwuBottom')}>
        <div>
          <img
            className={classes.logo}
            src={growWordLogoBlack}
            alt={'Marriott Logo'}
          />
        </div>
        <div className={classes.terms}>
          <a
            smooth="true"
            className={classes.termsLink}
            href="https://www.marriott.com/about/terms-of-use.mi"
            target="_blank"
            rel="noopener noreferrer"
          >
            {(lang.t('onboarding.terms.title2') === 'onboarding.terms.title2') && <span>Terms and Conditions <span style={{ display: 'none' }}Foo></span></span>}
            {(lang.t('onboarding.terms.title2') !== 'onboarding.terms.title2') && <span>{lang.t('onboarding.terms.title2')}</span>}
          </a> | <a
            smooth="true"
            className={classes.termsLink}
            onClick={onTermsClick}
          >
            {lang.t('onboarding.terms.title')}
          </a>
        </div>
      </div>
    </footer>
  );
};

const styles = {
  footer: {
    marginTop: remCalc(50),
    width: '100%',
    textAlign: 'center',
    '@media print': {
      display: 'none'
    }
  },
  top: {
    margin: remCalc(100, 0, 200),
    padding: remCalc(0, 210),
    ...getPhoneMediaQueriedStyle({
      padding: remCalc(0, 50)
    })
  },
  quoteImg: {
    ...getPropertyStyle('marginBottom', remCalc(40), remCalc(20))
  },
  quote: {
    fontFamily: 'DomaineDisplay-Bold',
    marginBottom: remCalc(25),
    fontSize: remCalc(64),
    lineHeight: remCalc(84),
    letterSpacing: remCalc(-0.94),
    ...getPhoneMediaQueriedStyle({
      fontSize: remCalc(30),
      lineHeight: remCalc(45),
    })
  },
  quoteBy: {
    fontSize: remCalc(24),
    lineHeight: remCalc(29),
    fontWeight: 700,
    ...getPhoneMediaQueriedStyle({
      fontSize: remCalc(16)
    })
  },
  bottom: {
    clipPath: 'polygon(0 0, 100% 16%, 100% 100%, 0% 100%)',
    position: 'relative',
    backgroundImage: `url(${shell})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '50px bottom',
    // backgroundSize: '30%',
    padding: remCalc(400, 100, 50, 0),
    textAlign: 'right',
    backgroundSize: '40%',
    backgroundColor: '#FFCB02',
    ...getPhoneMediaQueriedStyle({
      padding: remCalc(200, 25, 50),
      backgroundColor: '#FFCB02',
      backgroundPosition: 'left bottom',
      textAlign: 'center',
      backgroundSize: '80%'
    }),
    // ...getLargeMediaQueriedStyle({
    //   padding: remCalc(400, 100, 50, 0),
    //   textAlign: 'right',
    //   backgroundSize: '50%'
    // })
  },
  bottomSimple: {
    backgroundColor: '#FFCB02',
    padding: remCalc(50),
    right: 0,
    bottom: 0,
    left: 0
  },
  terms: {
    marginTop: remCalc(15),
  },
  termsLink: {
    color: textColor,
    cursor: 'pointer',
    textDecoration: 'underline !important',
    '&:hover': {
      color: textColor,
      textDecoration: 'underline !important',
    }
  },
  logo: {
    // ...getPhoneMediaQueriedStyle({
    //   width: '75%'
    // }),
  }
};

export default withStyles(styles)(GwuFooter);



// WEBPACK FOOTER //
// ./src/components/core/GwuFooter.js